/* ln-sort.js — real dropdown behaviour for the custom sort menu (.ln-sort).
   Closes on outside click and Escape; arrow-key navigation between options.
   Built on <details> so it works without JS too. */
(function () {
  function closeAll(except) {
    document.querySelectorAll('details.ln-sort[open]').forEach(function (d) {
      if (d !== except) d.open = false;
    });
  }

  document.addEventListener('click', function (e) {
    var openMenu = e.target.closest && e.target.closest('details.ln-sort[open]');
    closeAll(openMenu);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeAll(null);
      return;
    }
    var menu = document.querySelector('details.ln-sort[open]');
    if (!menu) return;
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      var opts = Array.prototype.slice.call(menu.querySelectorAll('.ln-sort__option'));
      var i = opts.indexOf(document.activeElement);
      var next = e.key === 'ArrowDown' ? i + 1 : i - 1;
      if (next < 0) next = opts.length - 1;
      if (next >= opts.length) next = 0;
      if (opts[next]) opts[next].focus();
    }
  });

  // When a menu opens, focus its active/first option for keyboard users
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d.matches && d.matches('details.ln-sort') && d.open) {
      var active = d.querySelector('.ln-sort__option--active') || d.querySelector('.ln-sort__option');
      if (active) setTimeout(function () { active.focus(); }, 0);
    }
  }, true);
})();
